import React, {Component} from 'react';
import { Tag } from 'antd';
import * as Types from './../../../utils/questionType'
import './style.css'
import './question.css'

//......各种类型的题
import QuestionFillinchinese from '../../question/fillinchinese/viewForView'; // 中文填空
import QuestionSolvingproblem from '../../question/solvingproblem/viewForView'; // 中文填空
import QuestionFillin from '../../question/fillin/viewForView';
import QuestionSelect from '../../question/select/viewForView';
import QuestionJudge from '../../question/judge/viewForView';
import QuestionHollow from '../../question/hollow/viewForView';
import QuestionMatch from '../../question/ligature/viewForView';
import QuestionClassify from '../../question/classify/viewForView';
import QuestionWordProblem from '../../question/wordproblem/viewForView';
import QuestionBankedCloze from '../../question/bankedcloze/viewForView';
import QuestionmakeSentences from '../../question/makeSentences/viewForView';
import QuestionSort from '../../question/sort/viewForView';
import QuestionVideoDubbing from '../../question/videodubbing/viewForView';
import QuestionEnFollow from '../../question/enfollow/viewForView';
import DeliverySecond from '../../question/deliverySecond/viewForView';

import QuestionSubjectivity from '../../question/subjectivity/viewForView';
import QuestionComposition from '../../question/composition/viewForView';
import QuestionSpokenWords from '../../question/spokenWords/viewForView';
import QuestionSpokenPhrase from '../../question/spokenPhrase/viewForView';
import QuestionSpokenSentence from '../../question/spokenSentence/viewForView';
import QuestionSpokenPassage from '../../question/spokenPassage/viewForView';
import QuestionSpokenPhonetic from '../../question/spokenPhonetic/viewForView';
import QuestionSemiOpen from '../../question/semiOpen/viewForView';
import QuestionSpokenPinyin from '../../question/spokenPinyin/viewForView';
import QuestionSpokenPhraseCn from '../../question/spokenPhraseCn/viewForView';
import QuestionSpokenSentenceCn from '../../question/spokenSentenceCn/viewForView';
import QuestionSpokenPassageCn from '../../question/spokenPassageCn/viewForView';
import Clue from '../../question/clue/viewForView';
import QuestionWriting from '../../question/writing/viewForView';

import QuestionDeclaim from '../../question/recite/viewForView'; //两个题型一样
import QuestionRecite from '../../question/recite/viewForView';

import QuestionEnRead from '../../question/enread/viewForView';
import QuestionCnRead from '../../question/cnread/viewForView';
import QuestionAisudoku from '../../question/ai_sudoku/viewForView';
import QuestionAisudokuParent from '../../question/ai_sudoku_parent/viewForView';
import QuestionAisudokuShip from '../../question/ai_sudoku_ship/viewForView';

import WordReading from '../wordReading/viewForView';
import SentenceFollow from '../sentenceFollow/viewForView';
import EssayReading from '../essayReading/viewForView';
import SituationalDialogue from '../situationalDialogue/viewForView';

import QuestionFillinBlank from '../../question/fillinblank/viewForView'; // 材料填空
import QuestionSentenceCloze from '../../question/sentencecloze/viewForView'; // 选词填空

import QuestionNaturefollow from '../../question/naturefollow/viewForView'; // 自然跟读
import QuestionNatureorder from '../../question/nlorder/viewForView'; // 自然排序
import QuestionNatureimg from '../../question/natureimg/viewForView'; // 自然单词图片
import QuestionNatureselect from '../../question/nlselect/viewForView'; // 自然选择

import QuestionJudgeRead from '../../question/judgeread/viewForView'; // 分级阅读评测
import QuestionJudgeSelect from '../../question/judgeselect/viewForView'; // 语文判分选择

import AiNumMatrix from '../../question/numMatrix/viewForView'; // AI数阵题
import AIEquation from '../../question/equation/viewForView'; // AI算式题
import AIEnumeration from '../../question/enumeration/viewForView'; // AI枚举题
import AIEnReading from '../../question/aiEnReading/viewForView'; // AI朗读题
import CleanDragFillin from '../../question/cleanDragFillin/viewForView'; // AI拖拽填空
import CleanDragSelect from '../../question/cleanDragSelect/viewForView'; // AI拖拽选择
import ReadNumber from '../../question/readNumber/viewForView';
//其他复用题型
import Exercise from '../exercise/view'

//AI英语寒假新题型
import WordSpell from '../../question/ai_word_spell/viewForView';//AI单词拼写
import WordSentences from '../../question/ai_word_sentences/viewForView';//AI连词成句
import FixDrag from '../../question/fixDrag/viewForView'; // AI定点拖拽
// modify by yangzc for 编程题
import QuestionProgram from '../../question/program/viewForView'; // 编程题
import ScratchJR from '../../question/scratchJR/viewForView'; // ScratchJR
import Scratch from '../../question/scratch/viewForView'; // Scratch
import WritingClass from '../../question/writingClass/viewForView'; // 写字课题型

class Question extends Component {
	state = {
		selectQuestions: [],
	}

	componentDidMount() {}


	render() {
		let {
			data = {}, errorAnswer, className,
			num = 0, canShowAnswer = 1, subject = '0',
			index, isChapter, showRelative
		} = this.props;
		num=num == 'undefined'?0:num
		let props = Object.assign({}, this.props);
		props.num = num

		data.isChapter = isChapter // 是否是章节tab
		data.showRelative = showRelative // 是否显示关联关系
		data.id = data.question_id;
		data.rate = data.right_rate

		let showAllAnswer = this.props.data.subject === '0'?true:false //给exercise用的

		return(
            // modify by yangzc for add program question 2023/9/6
			<div style={{position:'relative'}} className={className ? className : ''}>
                <div>
                    {
                        data.question_id_origin>0&&
                    		<div className="hu-title" >沪</div>

                    }
                </div>

                {
                		 //单词朗读
                    data.type_show == Types.TYPE_WORD_READING ?
                    <WordReading {...props} data={data}  canShowAnswer={canShowAnswer}/>:

                		 //句子跟读
                    data.type_show == Types.TYPE_SENTENCE_FOLLOW ?
                    <SentenceFollow {...props} data={data}  canShowAnswer={canShowAnswer}/>:

                		  //短文朗读
                    data.type_show == Types.TYPE_ESSAY_READING ?
                    <EssayReading {...props} data={data}  canShowAnswer={canShowAnswer}/>:

                		 //情景对话
                    data.type_show == Types.TYPE_SITUATIONAL_DIALOGUE ?
                    <SituationalDialogue {...props} data={data}  canShowAnswer={canShowAnswer}/>:
                    //中文填空题展示
                    data.type_show == Types.TYPE_SHOW_FILLIN_CHINESE ?
                    <QuestionFillinchinese {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    data.type_show == Types.TYPE_SHOW_SOLVINGPROBLEM ?
                    <QuestionSolvingproblem {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //填空题展示
                    data.type_show == Types.TYPE_SHOW_FILLIN ?
                    <QuestionFillin {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //选择题展示
                    (data.type_show == Types.TYPE_SHOW_SELECT||data.type_show == Types.TYPE_SHOW_MULTISELECT||data.type_show == Types.TYPE_SHOW_SELECT_PINYIN) ?
                    <QuestionSelect {...props} data={data} canShowAnswer={canShowAnswer}/>
                    :
                    //选择题展示 //听力
                    data.type_show == Types.TYPE_SHOW_SELECT_HEAR ?
                        <QuestionSelect {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //多选题展示
                    data.type_show == Types.TYPE_SHOW_MULTISELECT ?
                    <QuestionSelect {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //判断题展示
                    (data.type_show == Types.TYPE_SHOW_JUDGE || data.type_show == Types.TYPE_SHOW_JUDGE_PINYIN) ?
                    <QuestionJudge {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //判断题展示
                    data.type_show == Types.TYPE_SHOW_JUDGE_HEAR ?
                        <QuestionJudge {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //图片挖空题展示
                    data.type_show == Types.TYPE_SHOW_HOLLOW ?
                    <QuestionHollow {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //连线题展示
                    (data.type_show == Types.TYPE_SHOW_LIGATURE || data.type_show == Types.TYPE_SHOW_LIGATURE_PINYIN) ?
                    <QuestionMatch {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //连线题展示
                    data.type_show == Types.TYPE_SHOW_LIGATURE_HEAR ?
                        <QuestionMatch {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //分类题展示
                    (data.type_show == Types.TYPE_SHOW_CLASSIFY || data.type_show == Types.TYPE_SHOW_CLASSIFY_PINYIN) ?
                    <QuestionClassify {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //应用题展示
                    data.type_show == Types.TYPE_SHOW_WORDPROBLEM ?
                    <QuestionWordProblem {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //选词填空题展示
                    (data.type_show == Types.TYPE_SHOW_BANKEDCLOZE||data.type_show == Types.TYPE_SHOW_BANKEDCLOZE_PINYIN) ?
                    <QuestionBankedCloze {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    // 连词成句题展示
                    (data.type_show == Types.TYPE_SHOW_MAKESENTENCES || data.type_show == Types.TYPE_SHOW_MAKESENTENCES_PINYIN) ?
                    <QuestionmakeSentences {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //排序题展示
                    (data.type_show == Types.TYPE_SHOW_SORT || data.type_show == Types.TYPE_SHOW_SORT_PINYIN) ?
                    <QuestionSort {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //排序题展示
                    data.type_show == Types.TYPE_SHOW_SORT_HEAR ?
                    <QuestionSort {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //朗读题展示
                    data.type_show == Types.TYPE_SHOW_DECLAIM ?
                    <QuestionDeclaim {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //背诵题展示
                    data.type_show == Types.TYPE_SHOW_RECITE ?
                    <QuestionRecite {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //视频配音题
                    data.type_show == Types.TYPE_SHOW_VIDEO ?
                    <QuestionVideoDubbing {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //阅读题展示
                    data.type_show == Types.TYPE_SHOW_EN_READ ?
                    <QuestionEnRead {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //阅读题展示
                    data.type_show == Types.TYPE_SHOW_EN_READ_HEAR ?
                    <QuestionEnRead {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //阅读题展示
                    data.type_show == Types.TYPE_SHOW_CN_READ ?
                    <QuestionCnRead {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //阅读题展示
                    data.type_show == Types.TYPE_SHOW_NEW_FOLLOW ?
                    <QuestionEnFollow {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //阅读题展示
                    data.type_show == Types.TYPE_SHOW_NEW_READ_ALOUD ?
                    <QuestionEnFollow {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //阅读题展示
                    data.type_show == Types.TYPE_SHOW_NEW_RECITE ?
                    <QuestionEnFollow {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    // 材料填空
                    data.type_show == Types.TYPE_SHOW_FILLINBLANK ?
                    <QuestionFillinBlank {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    // 选词填空
                    data.type_show == Types.TYPE_SHOW_SENTENCECLOZE ?
                    <QuestionSentenceCloze {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //ai数独题展示
                    data.type_show == Types.TYPE_SHOW_NEW_AISUDUKU ?
                    <QuestionAisudoku {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //ai数独题展示
                    data.type_show == Types.TYPE_SHOW_NEW_AISUDUKU_PARENT ?
                    <QuestionAisudokuParent {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //ai数独题展示
                    data.type_show == Types.TYPE_SHOW_NEW_AISUDUKU_SHIP ?
                    <QuestionAisudokuShip {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //主观题
                    data.type_show == Types.TYPE_SHOW_SUBJECTIVITY ?
                    <QuestionSubjectivity data={data} {...props} canShowAnswer={canShowAnswer}/>
                    :
                    //作文题
                    data.type_show == Types.TYPE_SHOW_COMPOSITION ?
                    <QuestionComposition data={data} {...props} canShowAnswer={canShowAnswer}/>
                    :
                    //口语单词
                    data.type_show == Types.TYPE_SHOW_SPOKENWORDS ?
                    <QuestionSpokenWords data={data} {...props} canShowAnswer={canShowAnswer}/>
                    :
                    //口语短语
                    data.type_show == Types.TYPE_SHOW_SPOKENPHRASE ?
                    <QuestionSpokenPhrase data={data} {...props} canShowAnswer={canShowAnswer}/>
                    :
                    //口语句子
                    data.type_show == Types.TYPE_SHOW_SPOKENSENTENCE ?
                    <QuestionSpokenSentence data={data} {...props} canShowAnswer={canShowAnswer}/>
                    :
                    //口语段落
                    data.type_show == Types.TYPE_SHOW_SPOKENPASSAGE ?
                    <QuestionSpokenPassage data={data} {...props} canShowAnswer={canShowAnswer}/>
                    :
                    // 口语音标
                    data.type_show == Types.TYPE_SHOW_SPOKEN_PHONETIC ?
                    <QuestionSpokenPhonetic data={data} {...props} canShowAnswer={canShowAnswer}/>
                    :
                    // 半开放题
                    data.type_show == Types.TYPE_SHOW_SEMIOPEN ?
                    <QuestionSemiOpen data={data} {...props} canShowAnswer={canShowAnswer}/>
                    :
                    // 口语拼音
                    data.type_show == Types.TYPE_SHOW_SPOKEN_PINYIN ?
                    <QuestionSpokenPinyin data={data} {...props} canShowAnswer={canShowAnswer}/>
                    :
                    // 语文口语短语题
                    data.type_show == Types.TYPE_SHOW_SPOKENPHRASE_CN ?
                    <QuestionSpokenPhraseCn data={data} {...props} canShowAnswer={canShowAnswer}/>
                    :
                    // 语文口语句子题
                    data.type_show == Types.TYPE_SHOW_SPOKENSENTENCE_CN ?
                    <QuestionSpokenSentenceCn data={data} {...props} canShowAnswer={canShowAnswer}/>
                    :
                    // 语文口语段落题
                    data.type_show == Types.TYPE_SHOW_SPOKENPASSAGE_CN ?
                    <QuestionSpokenPassageCn data={data} {...props} canShowAnswer={canShowAnswer}/>
                    :
                    // 写字题
                    data.type_show == Types.TYPE_SHOW_WRITING ?
                    <QuestionWriting data={data} {...props} canShowAnswer={canShowAnswer}/>
                    :
                    // 线索题
                    data.type_show == Types.TYPE_SHOW_CLUE ?
                    <Clue data={data} {...props} canShowAnswer={canShowAnswer}/>
                    :
                    // 自然跟读
                    data.type_show == Types.TYPE_SHOW_NATURE_FOLLOW ?
                    <QuestionNaturefollow {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    // 自然排序
                    data.type_show == Types.TYPE_SHOW_NL_ORDER ?
                    <QuestionNatureorder {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
	                //自然单词图片
	                data.type_show == Types.TYPE_SHOW_NATURE_IMG ?
	                <QuestionNatureimg {...props} data={data}  canShowAnswer={canShowAnswer}/>
	                :
		            //ai数独题展示
		            data.type_show == Types.TYPE_SHOW_NL_SELECT ?
		            <QuestionNatureselect {...props} data={data}  canShowAnswer={canShowAnswer}/>
		            :
	                // 分级阅读评测
	                data.type_show == Types.TYPE_JUDGE_READING ?
	                <QuestionJudgeRead {...props} data={data}  canShowAnswer={canShowAnswer} />
	                :
	                // 分级阅读评测
	                data.type_show == Types.TYPE_JUDGE_SELETE ?
	                <QuestionJudgeSelect {...props} data={data}  canShowAnswer={canShowAnswer} />
	                :
	                // AI算式题
	                data.type_show == Types.TYPE_SHOW_EQUATION ?
	                <AIEquation {...props} data={data}  canShowAnswer={canShowAnswer} />
	                :
	                 // AI枚举题
	                data.type_show == Types.TYPE_SHOW_ENUMERATION ?
	                <AIEnumeration {...props} data={data}  canShowAnswer={canShowAnswer} />
                    :
                    // 数阵题
                    data.type_show == Types.TYPE_SHOW_NUM_MATRIX ?
                    <AiNumMatrix {...props} data={data}  canShowAnswer={canShowAnswer} />
                    :
                    // 脱式题二期
                    data.type_show == Types.TYPE_DELIVERY_SECOND ?
                    <DeliverySecond {...props} data={data}  canShowAnswer={canShowAnswer} />
                    :
                    // ai朗读题
                    [Types.TYPE_SHOW_AIEN_WORD_READING,Types.TYPE_SHOW_AIEN_SENTENCE_READING].includes(data.type_show)?
                    <AIEnReading {...props} data={data}  canShowAnswer={canShowAnswer} />
                    :// 拖拽填空
                    [
                    		Types.TYPE_SHOW_AI_FIX_DRAG_FILLIN,Types.TYPE_SHOW_AI_CLEAN_FILLIN,Types.TYPE_SHOW_AI_UNFIX_DRAG_FILLIN
                    ].includes(data.type_show)?
                    <CleanDragFillin {...props} data={data}  canShowAnswer={canShowAnswer} />
                    :// 拖拽选择
                    [
                    		Types.TYPE_SHOW_AI_FIX_DRAG_SELECT,Types.TYPE_SHOW_AI_CLEAN_SELECT,Types.TYPE_SHOW_AI_UNFIX_DRAG_SELECT,
                    ].includes(data.type_show)?
                    <CleanDragSelect {...props} data={data}  canShowAnswer={canShowAnswer} />
                    :
                      // 读数题
                    data.type_show == Types.TYPE_SHOW_AI_READ_NUMBER ?
                    <ReadNumber {...props} data={data}  canShowAnswer={canShowAnswer} />
                    :
						// AI单词拼写
					data.type_show == Types.TYPE_SHOW_AI_WORD_SPELL ?
					<WordSpell {...props} data={data} canShowAnswer={canShowAnswer}/>
					:
					//	AI连词成句
					data.type_show == Types.TYPE_SHOW_AI_CONNECT_WORDS ?
					<WordSentences {...props} data={data} canShowAnswer={canShowAnswer}/>
					:
					// 定点拖拽
					data.type_show == Types.TYPE_SHOW_AI_FIX_DRAG ?
					<FixDrag {...props} data={data}  canShowAnswer={canShowAnswer} />
                    :
                    //填空题2
                    data.type_show == Types.TYPE_SHOW_FILLIN_2 ?
                    <QuestionFillin {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //选择题2
                    (data.type_show == Types.TYPE_SHOW_SELECT_2) ?
                    <QuestionSelect {...props} data={data} canShowAnswer={canShowAnswer}/>
                    :
                    //判断题2
                    (data.type_show == Types.TYPE_SHOW_JUDGE_2) ?
                    <QuestionJudge {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //应用题2
                    data.type_show == Types.TYPE_SHOW_WORDPROBLEM_2 ?
                    <QuestionFillin {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //操作题
                    data.type_show == Types.TYPE_SHOW_CAOZUO ?
                    <QuestionFillin {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    //填空题2
                    data.type_show == Types.TYPE_SHOW_PROGRAM ?
                    <QuestionProgram {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    // ScratchJR题型 add by john 2024/4/10
                    data.type_show == Types.TYPE_SHOW_SCRATCHJR ?
                    <ScratchJR {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    // Scratch题型 add by john 2024/4/10
                    data.type_show == Types.TYPE_SHOW_SCRATCH ?
                    <Scratch {...props} data={data}  canShowAnswer={canShowAnswer}/>
                    :
                    data.type_show == Types.TYPE_SHOW_WRITINGCLASS ?
                    <WritingClass {...props} data={data}  canShowAnswer={canShowAnswer} />
                    :
                    Exercise({data,errorAnswer,num,canShowAnswer,subject,showAllAnswer})
                }

            </div>
		)
	}
}

export default Question


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/question_view/view.js